import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';
import RADApplication from '@/Management/RADApplication';

export default class ColumnLayoutItemBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.columnLayoutItem = {
            init: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let options = valueAccessor();

                if (options.tuple != null) {
                    let alignment = 'c-alignment-' + RADApplication.getInstance().getSystemParam('Gui.LabelAlignment');

                    $('<div class="c-caption ' + alignment + '">').append(options.tuple.label).appendTo(element);
                    $('<div class="c-control">').append(options.tuple.control).appendTo(element);

                    if (options.tuple.factory.labelPosition) {
                        element.addClass('c-labelposition-' + options.tuple.factory.labelPosition.toLowerCase());
                    }
                }
            }
        };
    }
}